var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 23,
    viewBox: "0 0 59 55"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#246CFF",
    d: "M40.86 54.078 34.084 42.24a8.5 8.5 0 0 0-7.385-4.28l-18.424.01a8.056 8.056 0 0 0-8.051 8.055 8.05 8.05 0 0 0 8.051 8.052z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF395A",
    d: "m6.282 33.432 13.545.01a8.5 8.5 0 0 0 7.387-4.278l9.257-16.161a8.06 8.06 0 0 0-2.944-10.977 7.964 7.964 0 0 0-10.911 2.923z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC7D7",
    d: "M41.278 13.706 34.496 25.43a8.5 8.5 0 0 0 .012 8.536l9.367 16.097a8.06 8.06 0 0 0 10.979 2.939 7.964 7.964 0 0 0 2.924-10.911z"
  }))));
};
export default SvgLogo;